export var EMVService;
(function (EMVService) {
    EMVService["Tmds"] = "TMDS";
    EMVService["Pdg"] = "PDG";
    EMVService["None"] = "NONE";
})(EMVService || (EMVService = {}));
